import type { Theme } from '@/constants';
import type { ThemeMap } from './types';

export function getThemeMap<T extends Theme>(theme: T) {
  if (theme === 'default') {
    return { light: 'light', dark: 'dark' } as ThemeMap<T>;
  }

  return {
    light: `light-${theme}`,
    dark: `dark-${theme}`,
  } as ThemeMap<T>;
}
